import { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Swal from "sweetalert2";
import { Form, Input, Select, Tooltip, Button, Row, Col, Collapse,UploadFile, UploadProps } from "antd";
import {
    uploadUserCoupon,
} from "../../../services/timesPoint/coupons";
import { startLoader, stopLoader } from "../../../libs/utils";

const { Panel } = Collapse;
const { Option } = Select;

function CreateAndAssignCoupon() {
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const formRef = useRef();
 
  const submitProduct = async (values) => {
    //setIsSubmitting(true);
    const formData = new FormData();
    let file = document.getElementById("userfile").files[0];
    formData.append('coupon_code',values.coupon_code);
    formData.append('user_csv',file);
    formData.append('coupon_amount',values.coupon_amount);
    formData.append('product_id',values.product_id);

    
    const uploadCouponRes = await uploadUserCoupon(formData)
    const { success, error } = uploadCouponRes || {};
    setIsSubmitting(false);
    if (success) {
      Swal.fire({
        title: "Success",
        text: "Coupon has been assigned successfully",
        icon: "success",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
          //navigate("/app/list-earn-activities");
        }
      });
      return;
    }
    Swal.fire({
      title: "Oops",
      text: error,
      icon: "warning",
      confirmButtonText: "Ok",
    });
  };

 


  return (
    <>
      <Box sx={{ ml: "4", pt: "14 !important", pb: "5", px: 3 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "25px",
            marginTop: "20px",
            gap: "16px",
          }}
        >
          <Link to={"/app/list-earn-activities"}>
            <ArrowBackIcon
              fontSize="large"
              l
              color="secondary"
              sx={{ background: "#040721", p: 1, borderRadius: "50%" }}
            />
          </Link>
          <Typography
            variant="h5"
            component="h5"
            fontWeight={"bold"}
            color={"#3d3d3d"}
          >
             Add Coupons
          </Typography>
        </div>
        <Box sx={{ background: "#ffffff", p: 2, mb: 4, pb: 4 }}>
          <div>
            <Form
              style={{ marginTop: "35px" }}
              layout={"vertical"}
              ref={formRef}
              name="control-ref"
              onFinish={submitProduct}
            >
              <Row gutter={[20, 0]}>
                <Col span={8}>
                  <Form.Item
                    name="coupon_code"
                    label="Coupon Code"
                    rules={[{ required: true }]}
    
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    name="coupon_amount"
                    label="Coupon Amount"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="product_id"
                    label="Product Id"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                <Form.Item
                    name="user_csv"
                    label="Users Csv"
                    rules={[{ required: true }]}
                  >
                    <Input type="file" id="userfile"/>
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={isSubmitting}
                  loading={isSubmitting}
                  style={{ marginTop: "25px" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Box>
      </Box>
    </>
  );
}

export default CreateAndAssignCoupon;
